<template>
  <div class="country-code" @click="switchMenuShow" v-clickoutside="clickOutside">
    <div class="el-dropdown-link">
      <span class="country flag-icon" :class="'flag-icon-' + alphaCode"></span>
      <span class="code">+{{code}}</span>
      <img style="width: 9px;height: 9px;margin-right: -5px;" src="../../assets/images/new-login-2018/下拉.png">
    </div>
    <!-- <el-collapse-transition> -->
    <div class="el-dropdown-menu" v-show="menuShow">
      <div class="item" v-for="country in countryCode" @click="selectCountry(country)">
        {{country.country + ' (+' + country.code + ')'}}
      </div>
    </div>
    <!-- </el-collapse-transition> -->
    <!-- <el-dropdown trigger="click" placement="top-start" @command="selectCountry">
      <span class="el-dropdown-link">
        <span class="country flag-icon" :class="'flag-icon-' + alphaCode"></span>
        <span class="code">+{{code}}</span>
        <img style="width: 9px;height: 9px;margin-right: -5px;" src="../../assets/images/new-login-2018/下拉.png">
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item style="font-size: 12px;" v-for="country in countryCode" :command="country">{{country.country + ' (+' + country.code + ')'}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>

<script>
  import config from '@/assets/js/config'
  import { getCountryCode } from '../common/CountryCode.js'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  export default {
    data () {
      return {
        menuShow: false,
        code: '',
        user: {},
        alphaCode: '',
        countryCode: []
      }
    },
    async mounted () {
      let res = await getCountryCode()
      this.countryCode = res.countryInfo
      this.user = res.user
      this.code = this.user['country_code']
      this.alphaCode = this.user.alphaCode
    },
    watch: {
      code () {
        this.$emit('sendCountryCode', this.code)
      }
    },
    methods: {
      selectCountry (country) {
        if (config.isLogin) {
          uploadWebEvent('SIGNUP_PHONE_COUNTRYCODE') // 埋点统计：手机号注册输入验证码页面切换国别码
        } else {
          uploadWebEvent('INVITE_PHONE_COUNTRYCODE') // 埋点统计：手机号注册输入验证码页面切换国别码
        }
        this.code = country.code
        this.alphaCode = country.alphaCode
      },
      clickOutside () {
        this.menuShow = false
      },
      switchMenuShow () {
        this.menuShow = !this.menuShow
        // let aaa = document.getElementsByTagName('body')[0]
        // let bbb = document.getElementsByTagName('body')[0].lastChild.style.cssText
        // let ccc = bbb.indexOf('left: ') + 5
        // let ddd = bbb.indexOf('px; transform')
        // let eee = +bbb.substring(ccc, ddd) + 110
        // document.getElementsByTagName('body')[0].lastChild.style.cssText = bbb.substring(0, ccc) + eee + bbb.substring(ddd)
        // console.log(document.getElementsByTagName('body')[0].lastChild.style.cssText)
        // document.getElementsByTagName('body')[0].lastChild.style.marginLeft = eee + 'px'
      }
    }
  }
</script>

<style lang="scss" scoped>
	.country-code {
    width: 100px;
    height: 40px;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    position: relative;
    .el-dropdown-link {
      width: 100px;
      height: 40px;
      display: block;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      .country {
        width: 28px;
        height: 21px;
        margin: 9px 0 0 5px;
        border-radius: 2px;
        float: left;
      }
      .code {
        width: 40px;
        margin: 0 -10px 0 5px;
        float: left;
      }
    }
    .el-dropdown-menu {
      width: 210px;
      height: 150px;
      margin-top: 45px;
      border: 1px solid #eeeeee;
      border-radius: 2px;
      overflow-y: auto;
      .item {
        height: 30px;
        font-size: 12px;
        border-bottom: 1px solid #eeeeee;
        line-height: 30px;
        padding-left: 10px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Countrycode.vue?2befee96